import { Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import styles from "../Staffs/Staffs.module.css";

import { ReactComponent as TimeIcon } from "../../../assets/svg/time.svg";
import Summery from "./Summery/Summery";

const Customers = () => {

  const customers = [
    {
      name: "David Gill",
      time: '17/05/2023',
      phone_number: "+968 (778) 991-4433",
      active: true,
    },
    {
      name: "Justus M",
      time: '17/05/2023',
      phone_number: "+968 (778) 991-4423",
      active: true,
    },
  ];

  return (
    <Page
      showFooter
      customPageClassName="px-3 mt-3"
      customHeader={<HeaderBack title="My Customers" url={"/profile/"} />}
      headerFix
      logo
      noFooter
      back
    >
      {customers.map((customer) => {
        return (
          <div className={styles.Box}>
            <div className={styles.BoxRow}>
              <span className={styles.BoxTitle}>{customer.name}</span>
              <span><TimeIcon width={13} className="me-2"/>{customer?.time}</span>
            </div>
            <div className={styles.BoxRow}>
              <span>{customer.phone_number}</span>
            </div>
          </div>
        );
      })}
      <Summery summery={{
        total_quantity: 2,
        total_amount: "23",
        payable_amount: "12"
      }} />
    </Page>
  );
};

export default Customers;
